<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			信息查看
		</div>

		<div @click="getlist" :class="!qbeada?'czxa':'zxcas'"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;">
			查看客户信息 <span style="color: red;">{{kh}}条未读</span>
		</div>
		<div @click="getlists" :class="qbeada?'czxa':'zxcas'"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 10px;">
			查看系统消息 <span style="color: red;">{{xt}}条未读</span>
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div
				style="width: 200px;height: 30px;font-weight: 800;text-align: center;line-height: 30px;font-size: 18px;margin-left: 20px;">
				<el-radio-group v-model="cid">
					<el-radio-button label="2">系统消息</el-radio-button>
					<el-radio-button label="3">客户消息</el-radio-button>
				</el-radio-group>
			</div>
		</div>
 -->
		<div style="width: 100%;min-height: 300px;margin-top: 55px;">
			<div style="width: 90%;margin-left: 3%;min-height: 300px;margin-top: 25px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;"
					v-for="(item,index) in kh_list">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<div v-show="item.look=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;text-align: center;">
							未查看
						</div>
						<div v-show="item.look=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;text-align: center;">
							已查看
						</div>
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div v-show="item.follow_status == 1"  @click="ck(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;text-align: center;">
							系统消息
						</div>
						<div v-show="item.follow_status == 2" @click="hfo(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;text-align: center;">
							回复
						</div>
						<div v-show="item.follow_status == 2"  @click="ck(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;text-align: center;">
							客户消息
						</div>
						<div @click.stop="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;text-align: center;">
							删除
						</div>
					</div>
				</div>
			</div>

			<!-- 分页 -->
			<div style="height: 40px;text-align: center;margin-top: 55px;">
				<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
					:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
				</el-pagination>
			</div>
		</div>

		<!-- 遮罩层 -->
		<div v-show="isShow" style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.8);">
			<div style="width: 500px;height: 400px;background-color: #FFF;margin: 0 auto;margin-top: 10%;">
				<div style="height: 30px;position: relative;border-bottom: 1px solid #6e6e6e;">
					<div style="line-height: 30px;font-size: 24px;position: absolute;left: 20px;">
						消息记录
					</div>
					<div style="font-size: 24px;line-height: 30px;position: absolute;right: 20px;"
						@click="isShow = false">
						X
					</div>
				</div>
				<div style="width: 100%;height: 365px;padding: 5px;box-sizing: border-box;overflow: scroll;">
					<div style="width: 100%;height: 40px;margin-top: 5px;box-shadow: #6e6e6e 0px 0px 2px;"
						v-for="(item,index) in cks">
						<div style="width: 100%;height: 20px;line-height: 20px;font-size: 12px;">
							{{item.nickname}}{{getLocalTime(item.create_time)}}
						</div>
						<div style="width: 100%;height: 20px;line-height: 20px;font-size: 12px;">
							<!-- <span v-html="item.content"></span> -->
							{{item.content}}
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				cid: '2',
				list: [],
				xt_list: [],
				kh_list: [],
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				cks: '',
				xt: '',
				kh: '',
				qbeada: false,
			}
		},
		methods: {
			async getlist() {
				this.cid = '2'
				var that = this
				this.qbeada = false
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/customer_index', {
					uid: loginInfo.id
					// uid: 1
				})
				console.log(res)
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
				this.kh_list = res.data.data.list
			},
			 hfo(id) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				console.log(id)
				this.$prompt('请输入回复内容', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(async({
					value
				})  => {
					let res = await http.post('api/picture/customer_reply',{
						follow_status:'2',
						content :value,
						obj_id:id.obj_id,
						send_id:loginInfo.id
					})
					console.log(res)
					if(res.data.code==200){
						this.$message({
							type: 'info',
							message: '回复成功'
						});
					} else {
						this.$message({
							type: 'error',
							message: '回复失败'
						});
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			async getlists() {
				this.cid = '6'
				this.qbeada = true
				var that = this
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/system_index', {
					uid: loginInfo.id
					// uid: 1
				})
				console.log(res)
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
				this.kh_list = res.data.data.list
			},
			cnmck() {
				window.open('http://localhost:8080/#' + this.cks.pc_link, '_blank');
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.cid == '2') {
					let res = await http.get('api/picture/page_customer_index', {
						uid: loginInfo.id,
						// uid: 1,
						page: val
					})

					this.kh_list = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				} else {
					let res = await http.get('api/picture/page_system_index', {
						uid: loginInfo.id,
						// uid: 1,
						page: val
					})

					this.kh_list = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				}
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			async ck(item) {
				console.log(item)
				if (this.cid == '2') {
					this.wdxx()
					// console.log(item)
					// let res = await http.get('api/picture/consumption_detail', {
					// 	id: item.id
					// })
					let res = await http.get('api/picture/new_consumption_detail', {
						id: item.id
					})
					console.log(res)
					this.cks = res.data.data.list
					this.isShow = true
				} else {
					if (item.pc_link == '') {
						alert('跳转链接为空')
					} else {
						window.open('http://localhost:8080/#' + item.pc_link, '_blank');
					}
				}


			},
			async detela(item) {
				let res = await http.get('api/picture/personal_inform_delete', {
					id: item
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
				}
				if (this.cid == '6') {
					this.getlists();
				} else {
					this.getlist();
				}
			},
			async wdxx() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/unread_inform', {
					uid: loginInfo.id,
					// uid: 1,
				})
				console.log(res)
				this.xt = res.data.data.xt_inform
				this.kh = res.data.data.kh_inform
			},
			async wdxxs() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/unread_inform', {
					uid: loginInfo.id,
					// uid: 1,
				})
				console.log(res)
				this.xt = res.data.data.xt_inform
				this.kh = res.data.data.kh_inform
			},
		},
		mounted() {
			if (this.cid == '2') {
				this.getlist();
				this.wdxxs()
			} else {
				this.getlists();
				this.wdxx()
			}
		}
	}
</script>

<style>
	.czxa {
		color: #FFF;
		background-color: rgba(255, 68, 0, 0.3);
	}

	.zxcas {
		color: #000;
		background: #FFF;
	}
</style>
